// Importer les fonctions nécessaires de i18n.js
import { setLanguage, detectLanguage, updateUIText, getCurrentLanguage, translate } from './utils/i18n.ts';
// Importer la liste des fichiers HDR et presets
import { hdrFiles, controllerPresets } from './core/config.ts';
// Importer la fonction pour jouer les effets sonores
import { playSoundEffect } from './utils/audioUtils.ts';

document.addEventListener('DOMContentLoaded', () => {
    console.log("[Menu] DOM Chargé");

    // --- Encapsuler l'initialisation dans une fonction async ---
    (async () => {
        // --- Récupération des éléments du DOM (déplacé ici) ---
        const languageSelect = document.getElementById('languageSelect');
        const layoutToggleButton = document.getElementById('layoutToggleButton');
        const soundToggleButton = document.getElementById('sound-toggle-button');
        const modeButtons = document.querySelectorAll('.mode-button');
        const customMissionSetupSection = document.getElementById('custom-mission-setup');
        const customEnvironmentSelect = document.getElementById('custom-environment');
        const customOpponentsSlider = document.getElementById('custom-opponents');
        const opponentsValueSpan = document.getElementById('opponents-value');
        const customLapsSlider = document.getElementById('custom-laps');
        const lapsValueSpan = document.getElementById('laps-value');
        const customObstaclesSlider = document.getElementById('custom-obstacles');
        const obstaclesValueSpan = document.getElementById('obstacles-value');
        const customTrackShapeSelect = document.getElementById('custom-track-shape');
        const customTrackComplexitySlider = document.getElementById('custom-track-complexity');
        const complexityValueSpan = document.getElementById('complexity-value');
        const customTrackSizeSlider = document.getElementById('custom-track-size');
        const sizeValueSpan = document.getElementById('size-value');
        const customTrackElevationSlider = document.getElementById('custom-track-elevation');
        const elevationValueSpan = document.getElementById('elevation-value');
        const customTrackIrregularitySlider = document.getElementById('custom-track-irregularity');
        const irregularityValueSpan = document.getElementById('irregularity-value');
        const customTimeLimitSelect = document.getElementById('custom-time-limit');
        const customAIDifficultySelect = document.getElementById('custom-ai-difficulty');
        const controllerPresetSection = document.getElementById('controller-preset-section');
        const controllerPresetSelect = document.getElementById('controller-preset-select');
        const controllerPresetDescription = document.getElementById('controller-preset-description');
        const shipButtons = document.querySelectorAll('.ship-button');
        const startButton = document.getElementById('startGame');
        const menuMusic = document.getElementById('menu-background-music');

        // --- Nouveaux sélecteurs pour la section Custom Exploration ---
        const customExplorationSetupSection = document.getElementById('custom-exploration-setup');
        const customExplorationEnvironmentSelect = document.getElementById('custom-expl-environment');
        const customExplorationObstaclesSlider = document.getElementById('custom-expl-obstacles');
        const obstaclesExplValueSpan = document.getElementById('expl-obstacles-value');
        const customExplorationSpeedSlider = document.getElementById('custom-expl-speed');
        const speedExplValueSpan = document.getElementById('expl-speed-value');
        const customExplorationTimerSelect = document.getElementById('custom-expl-timer');
        // --- Fin Nouveaux sélecteurs ---

        // <<< ADDED: Selectors for Mission Modes >>>
        const customCourseSetupSection = document.getElementById('custom-mission-setup');
        // Add selectors for specific controls inside customMissionSetupSection later
        // <<< END ADDED >>>

        // --- Variables d'état globales au menu (déplacé ici) ---
        let selectedMode = localStorage.getItem('genesisTrail_gameMode') || null;
        let selectedShipOption = document.querySelector('.ship-button.selected');
        let selectedShip = selectedShipOption ? selectedShipOption.dataset.ship : null;
        let customCourseConfig = JSON.parse(localStorage.getItem('genesisTrail_customCourseConfig') || '{}');
        let customExplorationConfig = JSON.parse(localStorage.getItem('genesisTrail_customExplorationConfig') || '{}');
        // <<< ADDED: State for Custom Mission Config >>>
        let customMissionConfig = JSON.parse(localStorage.getItem('genesisTrail_customMissionConfig') || '{}');
        // <<< END ADDED >>>
        let selectedControllerPreset = localStorage.getItem('genesisTrail_controllerPreset') || 'default';
        let isMenuSoundMuted = localStorage.getItem('genesisTrail_menuSoundMuted') === 'true';
        let currentLayout = localStorage.getItem('genesisTrail_menuLayout') || 'portrait';
        const shipsWithoutCustomColors = [];
        let focusableElements = [];
        let currentFocusIndex = -1;
        const focusClass = 'focused-by-input';
        let gamepadConnected = false;
        let lastInputType = 'mouse';
        const inputStateMenu = {
            navUp: false, navDown: false, navLeft: false, navRight: false,
            activate: false, valueUp: false, valueDown: false, valueLeft: false, valueRight: false,
            startGameShortcut: false, _rawKeyDown: {}, _rawKeyUp: {}, _rawGamepadButton: {}, _rawGamepadAxis: {}
         };
        const inputHandled = {
            navUp: false, navDown: false, navLeft: false, navRight: false, activate: false,
            valueChange: false, startGameShortcut: false
         };
        let startGameButtonSpan = null;
        let startGameOriginalTranslateKey = null;
        const MENU_SOUND_VOLUME = 0.3;
        let firstInteractionDone = false;

        // --- Apply initial sound volume ---
        if (menuMusic) {
            menuMusic.volume = MENU_SOUND_VOLUME;
        }
        // --- End Apply initial sound volume ---

        // --- Nouvelle fonction pour gérer l'état de la manette et la visibilité de la section preset ---
        function checkGamepadStatus() {
            const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
            let found = false;
            for (let i = 0; i < gamepads.length; i++) {
                if (gamepads[i]) {
                    found = true;
                    break;
                }
            }
            gamepadConnected = found; // Mettre à jour l'état global

            // Gérer la visibilité de la section
            if (controllerPresetSection) {
                controllerPresetSection.style.display = gamepadConnected ? '' : 'none';
                console.log(`[Gamepad Status] Connected: ${gamepadConnected}, Section display: ${controllerPresetSection.style.display}`);
            } else {
                console.warn("[Gamepad Status] Section Preset non trouvée.");
            }
            
            updateFocusableElements(); // Mettre à jour les éléments focusables après changement de visibilité
            updateStartButtonTextHint(gamepadConnected); // Mettre à jour l'indice (Start) sur le bouton
        }

        // --- Détecter la langue initiale via i18n (MAINTENANT AVEC AWAIT) ---
        console.log("[Menu] Détection de la langue...");
        try {
            await detectLanguage(); // Attend que la langue soit détectée et les traductions chargées
            console.log(`[Menu] Langue initiale détectée/définie: ${getCurrentLanguage()}`);

            // --- Mettre à jour l'UI après chargement des traductions (déplacé ici) ---
            updateUIText();
            setupControllerPresetSelector(); // Maintenant que i18n est prêt
            updatePresetDescription(selectedControllerPreset); // Mettre à jour la description initiale
            updateModeDescription(); // Mettre à jour la description du mode initial (si un mode est sélectionné)

            // --- Initialiser l'état visuel du bouton son après traduction ---
            updateSoundButtonVisuals();

        } catch (error) {
             console.error("[Menu] Erreur lors de l'initialisation de i18n:", error);
             // Gérer l'erreur (ex: afficher message, utiliser fallback)
             // Pour l'instant, on continue avec les fonctions potentiellement non traduites
             // --- Initialiser l'état visuel du bouton son même en cas d'erreur i18n ---
             updateSoundButtonVisuals();
        }

        // --- Définition des fonctions utilitaires (inchangées dans leur contenu) ---
        // function applyLayout(...) { ... }
        // function toggleLayout(...) { ... }
        // function populateEnvironmentSelector(...) { ... }
        // ... (toutes les fonctions utilitaires: updateColor, checkStart, updatePreset, launchGame, etc.) ...
        // NOTE: Le contenu des fonctions reste le même, seule la manière de les appeler ou leur contexte (async) change si elles appellent des fonctions i18n async

        function applyLayout(layout) {
            const screenWidth = window.innerWidth;
            const forcePortrait = screenWidth <= 480;
            let finalLayout = forcePortrait ? 'portrait' : layout;

            if (finalLayout === 'landscape') {
                document.body.classList.add('layout-landscape');
                layoutToggleButton.textContent = '↕️';
                layoutToggleButton.title = translate('layout.toggle.portrait');
            } else {
                document.body.classList.remove('layout-landscape');
                layoutToggleButton.textContent = '↔️';
                layoutToggleButton.title = translate('layout.toggle.landscape');
            }
            updateFocusableElements();
            // console.log(`[Layout] Demandé: ${layout}, Appliqué: ${finalLayout}`); // Log moins verbeux
        }

        function toggleLayout() {
            currentLayout = (currentLayout === 'portrait') ? 'landscape' : 'portrait';
            localStorage.setItem('genesisTrail_menuLayout', currentLayout);
            applyLayout(currentLayout);
        }

        function populateEnvironmentSelector(selectElement, configObjectKey) {
            if (!selectElement) return;
            selectElement.innerHTML = ''; // Vider
            hdrFiles.forEach((filename, index) => {
                const option = document.createElement('option');
                option.value = index;
                const readableName = filename.replace(/_puresky_4k|_4k|_2_4k|_1k|\.hdr$/gi, '').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                option.textContent = readableName;
                selectElement.appendChild(option);
            });
            const darkVoidOption = document.createElement('option');
            darkVoidOption.value = '-1'; darkVoidOption.textContent = 'DarkVoid';
            selectElement.appendChild(darkVoidOption);
            
            // Restaurer la sélection depuis l'objet config correspondant
            const savedIndex = configObjectKey === 'customCourse' 
                               ? customCourseConfig.environmentIndex 
                               : customExplorationConfig.environmentIndex;
            if (savedIndex !== undefined) {
                 selectElement.value = savedIndex;
            } else {
                selectElement.selectedIndex = 0; // Défaut première option
            }
        }

        function checkStartConditions() {
            const modeIsSelected = selectedMode !== null;
            const shipIsSelected = selectedShip !== null;
            const canStart = modeIsSelected && shipIsSelected;
            // let vrPossible = true; // Vérification VR plus nécessaire ici
            // try { vrPossible = navigator.xr && await navigator.xr.isSessionSupported('immersive-vr'); } catch { vrPossible = false; }

            if (startButton) startButton.disabled = !canStart;
            // if (startVRButton) { // <<< SUPPRIMÉ
            //      startVRButton.disabled = !canStart; // || !vrPossible; // <<< SUPPRIMÉ
            // } // <<< SUPPRIMÉ
            updateFocusableElements();
        }

        function updatePresetDescription(presetKey) {
            if (!controllerPresetDescription) return;
            const preset = controllerPresets[presetKey];
            const descKey = `preset.${presetKey}.description`;
            let description = translate(descKey);
            if (description === descKey) {
                description = preset?.description?.[getCurrentLanguage()]
                           || preset?.description?.['en']
                           || translate('preset.descriptionUnavailable');
            }
            controllerPresetDescription.innerHTML = `<small>${description}</small>`;
        }

        // --- Nouvelle fonction utilitaire pour gérer l'affichage des sections Custom ---
        // <<< DÉPLACÉE ICI, AVANT SON UTILISATION >>>
        function updateCustomSectionsVisibility() {
            if (!customMissionSetupSection || !customExplorationSetupSection || !customCourseSetupSection) { // Added customCourseSetupSection to the check
                console.warn("Section(s) custom non trouvée(s).");
                return;
            }
            const displayStyle = 'block'; 
            
            customCourseSetupSection.style.display = (selectedMode === 'customCourse') ? displayStyle : 'none';
            customExplorationSetupSection.style.display = (selectedMode === 'customExploration') ? displayStyle : 'none';
            // <<< ADDED: Handle Custom Mission Section >>>
            customMissionSetupSection.style.display = (selectedMode === 'customMission') ? displayStyle : 'none';
            // <<< END ADDED >>>

            updateFocusableElements(); // Important après changement de visibilité
        }
        // --- Fin déplacement fonction ---

        function setupControllerPresetSelector() {
            if (!controllerPresetSelect || !controllerPresets) return;
            controllerPresetSelect.innerHTML = '';
            Object.keys(controllerPresets).forEach(key => {
                const preset = controllerPresets[key];
                const option = document.createElement('option');
                option.value = key;
                const nameKey = `preset.${key}.name`;
                let name = translate(nameKey);
                if (name === nameKey) {
                    name = preset.name?.[getCurrentLanguage()] || preset.name?.en || key;
                }
                option.textContent = name;
                controllerPresetSelect.appendChild(option);
            });
            controllerPresetSelect.value = selectedControllerPreset;
            updatePresetDescription(selectedControllerPreset);
        }

        // <<< NOUVELLE FONCTION: Tenter de passer en plein écran >>>
        function enterFullscreen() {
            const element = document.documentElement; // Élément racine HTML
            if (element.requestFullscreen) {
                element.requestFullscreen().catch(err => console.error(`Erreur requestFullscreen: ${err.message}`));
            } else if (element.mozRequestFullScreen) { // Firefox
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) { // Chrome, Safari, Edge
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { // IE11
                element.msRequestFullscreen();
            }
        }
        // <<< FIN NOUVELLE FONCTION >>>

        function launchGame(startMode = 'non-vr') {
            if (!selectedMode || !selectedShip) {
                console.warn("Tentative de démarrage sans mode ou vaisseau sélectionné.");
                return;
            }

            // --- Play Start Sound ---
            playSoundEffect('start-game-sound', 0.6);
            // --- End Play Start Sound ---

            // --- Stop Menu Music ---
            if (menuMusic && !menuMusic.paused) {
                console.log("[Menu Audio] Arrêt de la musique du menu.");
                menuMusic.pause();
            }
            // --- End Stop Menu Music ---

            console.log(`[Menu] Lancement du jeu - Mode: ${selectedMode}, Vaisseau: ${selectedShip}, Type démarrage: ${startMode}`);

            // Sauvegarder les sélections finales
            localStorage.setItem('genesisTrail_gameMode', selectedMode);
            localStorage.setItem('genesisTrail_selectedShip', selectedShip);
            localStorage.setItem('genesisTrail_controllerPreset', selectedControllerPreset); // Sauvegarder aussi le preset

            // Sauvegarder la config custom si le mode est 'customCourse' ou 'customExploration'
            if (selectedMode === 'customCourse') {
                 // Collecter les valeurs actuelles des inputs de la section custom course
                 const courseConfig = {
                     environmentIndex: parseInt(customEnvironmentSelect.value, 10),
                     opponentCount: parseInt(customOpponentsSlider.value, 10),
                     lapCount: parseInt(customLapsSlider.value, 10),
                     obstacleCount: parseInt(customObstaclesSlider.value, 10),
                     trackShape: parseInt(customTrackShapeSelect.value, 10),
                     trackComplexity: parseInt(customTrackComplexitySlider.value, 10),
                     trackSize: parseInt(customTrackSizeSlider.value, 10),
                     trackElevation: parseInt(customTrackElevationSlider.value, 10),
                     trackIrregularity: parseInt(customTrackIrregularitySlider.value, 10),
                     timeLimit: parseInt(customTimeLimitSelect.value, 10), // Ajouter la limite de temps
                     aiDifficulty: customAIDifficultySelect.value // Ajouter la difficulté IA
                 };
                localStorage.setItem('genesisTrail_customCourseConfig', JSON.stringify(courseConfig));
                console.log('[Menu] Config Course Perso sauvegardée:', courseConfig);
            } else if (selectedMode === 'customExploration') {
                 // Collecter les valeurs actuelles des inputs de la section custom exploration
                 const explorationConfig = {
                     environmentIndex: parseInt(customExplorationEnvironmentSelect.value, 10),
                     obstacleCount: parseInt(customExplorationObstaclesSlider.value, 10),
                     shipSpeedMultiplier: parseFloat(customExplorationSpeedSlider.value),
                     timerDuration: parseInt(customExplorationTimerSelect.value, 10),
                 };
                localStorage.setItem('genesisTrail_customExplorationConfig', JSON.stringify(explorationConfig));
                console.log('[Menu] Config Exploration Perso sauvegardée:', explorationConfig);
            // <<< ADDED: Handle Custom Mission Config Saving >>>
            } else if (selectedMode === 'customMission') {
                // Collect config from customMissionSetupSection controls later
                const missionConfig = {}; // Placeholder for now
                localStorage.setItem('genesisTrail_customMissionConfig', JSON.stringify(missionConfig));
                console.log('[Menu] Config Mission Perso sauvegardée (placeholder):', missionConfig);
            // <<< END ADDED >>>
            }

            // Définir la page cible
            let finalLevelPath = 'game.html'; // Default for race/time modes

            // <<< MODIFIED: Choose target page based on mode >>>
            if (selectedMode && selectedMode.startsWith('mission_') || selectedMode === 'time_extension') {
                finalLevelPath = 'missions.html';
            } else if (selectedMode && (selectedMode === 'adventure' || selectedMode === 'exploration' || selectedMode === 'chaos' || selectedMode === 'extreme' || selectedMode === 'customExploration')) {
                finalLevelPath = 'adventure.html';
            }
            // <<< END MODIFIED >>>

            console.log(`[Menu] Redirection vers: ${finalLevelPath}`);

            // <<< MODIFICATION: Construire URL SANS paramètre VR >>>
            const baseUrl = window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '/';
            const url = new URL(finalLevelPath, baseUrl);

            // Ajouter le paramètre de démarrage VR si nécessaire
            // if (startMode === 'vr') { // <<< SUPPRIMÉ
            //      url.searchParams.set('startVR', 'true');
            //      console.log("[Menu] Paramètre startVR=true ajouté à l'URL.");
            // } // <<< SUPPRIMÉ

            // Rediriger vers l'URL construite
            window.location.href = url.toString();
            // <<< FIN MODIFICATION >>>
        }

        function updateFocusableElements() {
            const isCustomMode = selectedMode === 'custom';
            const isGamepadConnected = gamepadConnected;
            const startButtonsDisabled = startButton ? startButton.disabled : true;
            // Note: vr button state depends on startButton state now
            // const vrButtonDisabled = startVRButton ? startVRButton.disabled : true; // <<< SUPPRIMÉ

            const selectors = [
                '#languageSelect',
                '#layoutToggleButton',
                '#sound-toggle-button',
                '.mode-button',
                ...(isCustomMode ? ['#custom-environment', '#custom-opponents', '#custom-laps', '#custom-obstacles'] : []),
                ...(isGamepadConnected ? ['#controller-preset-select'] : []),
                '.ship-button',
                 // Inclure les boutons seulement s'ils ne sont PAS désactivés
                ...(!startButtonsDisabled ? ['#startGame'] : []),
                // ...(!vrButtonDisabled ? ['#startVR'] : []) // <<< SUPPRIMÉ
                // <<< ADDED: Potential custom mission elements >>>
                ...(selectedMode === 'customMission' ? ['#custom-mission-setup input', '#custom-mission-setup select', '#custom-mission-setup button'] : []) // Add specific elements later
                // <<< END ADDED >>>
            ];

            focusableElements = Array.from(document.querySelectorAll(selectors.join(', ')))
                .filter(el => {
                     const style = window.getComputedStyle(el);
                     const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
                     let parent = el.parentElement;
                     let parentVisible = true;
                     while (parent && parent !== document.body) {
                         const parentStyle = window.getComputedStyle(parent);
                          if (parentStyle.display === 'none' || parentStyle.visibility === 'hidden') {
                             parentVisible = false; break;
                         }
                         if (parent.classList.contains('menu-section') && parent.style.display === 'none') {
                             parentVisible = false; break;
                         }
                         parent = parent.parentElement;
                     }
                     const isPointerEventsNone = style.pointerEvents === 'none';
                     return isVisible && parentVisible && !isPointerEventsNone;
                 });

            if (currentFocusIndex >= focusableElements.length) {
                updateFocus(-1);
            } else if (currentFocusIndex !== -1) {
                 const currentFocusedElement = document.querySelector(`.${focusClass}`);
                 if (!focusableElements.includes(currentFocusedElement)) {
                      if (currentFocusedElement) {
                          currentFocusedElement.classList.remove(focusClass);
                          currentFocusedElement.blur();
                      }
                      currentFocusIndex = -1;
                 }
            }
        }

        function updateFocus(newIndex) {
            if (newIndex < -1 || newIndex >= focusableElements.length) return;
            if (currentFocusIndex !== -1 && focusableElements[currentFocusIndex]) {
                focusableElements[currentFocusIndex].classList.remove(focusClass);
                focusableElements[currentFocusIndex].blur();
            } else {
                 const previouslyFocused = document.querySelector(`.${focusClass}`);
                 if (previouslyFocused) previouslyFocused.classList.remove(focusClass);
            }
            currentFocusIndex = newIndex;
            if (currentFocusIndex !== -1) {
                const element = focusableElements[currentFocusIndex];
                element.classList.add(focusClass);
                element.focus();
                element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                lastInputType = 'keyboard';
            }
        }

        function navigate(direction) {
            if (focusableElements.length === 0) return;
            if (currentFocusIndex === -1) {
                updateFocus(0);
                return;
            }
            let newIndex = currentFocusIndex;
            const numElements = focusableElements.length;
            if (direction === 'Up' || direction === 'Left') {
                newIndex = (currentFocusIndex - 1 + numElements) % numElements;
            } else if (direction === 'Down' || direction === 'Right') {
                newIndex = (currentFocusIndex + 1) % numElements;
            }
            updateFocus(newIndex);
        }

        function activateFocusedElement() {
            if (currentFocusIndex === -1 || !focusableElements[currentFocusIndex]) return;
            const element = focusableElements[currentFocusIndex];
            // console.log(`[Input] Activation de:`, element);
            if (element.id === 'sound-toggle-button') {
                toggleMenuSound();
            } else {
                 element.click();
            }
        }

        function handleValueChange(element, direction) {
            if (!element) return;
            let changed = false;
            if (element.tagName === 'INPUT' && element.type === 'range') {
                let value = parseFloat(element.value);
                const step = parseFloat(element.step) || 1;
                const min = parseFloat(element.min);
                const max = parseFloat(element.max);
                if (direction === 'Left' && value > min) { value = Math.max(min, value - step); changed = true; }
                else if (direction === 'Right' && value < max) { value = Math.min(max, value + step); changed = true; }
                if(changed) element.value = value;
            } else if (element.tagName === 'SELECT') {
                let currentIndex = element.selectedIndex;
                const numOptions = element.options.length;
                if (direction === 'Up' && currentIndex > 0) { currentIndex--; changed = true; }
                else if (direction === 'Down' && currentIndex < numOptions - 1) { currentIndex++; changed = true; }
                if(changed) element.selectedIndex = currentIndex;
            }
            if(changed) {
                element.dispatchEvent(new Event(element.type === 'range' ? 'input' : 'change', { bubbles: true }));
                // console.log(`[Input] Value changed for ${element.id}: ${element.value}`); // Moins verbeux
            }
        }

        function handleMenuInputs() {
             Object.keys(inputStateMenu).forEach(key => { if (!key.startsWith('_')) inputStateMenu[key] = false; });
             const keys = inputStateMenu._rawKeyDown;
             let keyNavIntent = { up: keys['ArrowUp'], down: keys['ArrowDown'], left: keys['ArrowLeft'], right: keys['ArrowRight'] };
             let keyActivateIntent = keys['Enter'] || keys['Space'];
             let padNavIntent = { up: false, down: false, left: false, right: false };
             let padActivateIntent = false;
             let padStartIntent = false;
             const GAMEPAD_AXIS_THRESHOLD = 0.6;
             if (gamepadConnected) {
                 const gp = Array.from(navigator.getGamepads()).find(g => g && g.connected);
                 if (gp) {
                     lastInputType = 'gamepad';
                     const presetKey = selectedControllerPreset || 'default';
                     const preset = controllerPresets[presetKey] || controllerPresets['default'];
                     const mapping = preset.mapping;
                     const checkGamepadCondition = (actionName) => { /* ... */
                         if (!mapping || !mapping[actionName]) return false;
                         let isActive = false;
                         mapping[actionName].forEach(cond => {
                             if (isActive) return;
                             try {
                                 if (cond.type === 'button') {
                                     const button = gp.buttons[cond.index];
                                     if (button && (button.pressed || (cond.threshold && button.value >= (cond.threshold || 0.5)))) isActive = true;
                                 } else if (cond.type === 'axis') {
                                     const axisValue = gp.axes[cond.index] ?? 0;
                                     if ((cond.threshold > 0 && axisValue >= cond.threshold) || (cond.threshold < 0 && axisValue <= cond.threshold) || (cond.exactValue !== undefined && Math.abs(axisValue - cond.exactValue) < 0.1))
                                         isActive = true;
                                 }
                             } catch (e) { /* ignore */ }
                         });
                         return isActive;
                     };
                     const rawStickY = gp.axes[mapping?.leftStickY?.index ?? 1] ?? 0;
                     const rawStickX = gp.axes[mapping?.leftStickX?.index ?? 0] ?? 0;
                     padNavIntent.up = checkGamepadCondition('dpadUp') || rawStickY < -GAMEPAD_AXIS_THRESHOLD;
                     padNavIntent.down = checkGamepadCondition('dpadDown') || rawStickY > GAMEPAD_AXIS_THRESHOLD;
                     padNavIntent.left = checkGamepadCondition('dpadLeft') || rawStickX < -GAMEPAD_AXIS_THRESHOLD;
                     padNavIntent.right = checkGamepadCondition('dpadRight') || rawStickX > GAMEPAD_AXIS_THRESHOLD;
                     padActivateIntent = checkGamepadCondition('confirm');
                     padStartIntent = checkGamepadCondition('pause');
                     if (!padNavIntent.up) padNavIntent.up = gp.buttons[12]?.pressed ?? false;
                     if (!padNavIntent.down) padNavIntent.down = gp.buttons[13]?.pressed ?? false;
                     if (!padNavIntent.left) padNavIntent.left = gp.buttons[14]?.pressed ?? false;
                     if (!padNavIntent.right) padNavIntent.right = gp.buttons[15]?.pressed ?? false;
                     if (!padActivateIntent) padActivateIntent = gp.buttons[0]?.pressed ?? false;
                     if (!padStartIntent) padStartIntent = gp.buttons[9]?.pressed ?? false;
                 }
             }
             inputStateMenu.navUp = keyNavIntent.up || padNavIntent.up;
             inputStateMenu.navDown = keyNavIntent.down || padNavIntent.down;
             inputStateMenu.navLeft = keyNavIntent.left || padNavIntent.left;
             inputStateMenu.navRight = keyNavIntent.right || padNavIntent.right;
             inputStateMenu.activate = keyActivateIntent || padActivateIntent;
             inputStateMenu.startGameShortcut = padStartIntent;
             const focusedElement = (currentFocusIndex !== -1) ? focusableElements[currentFocusIndex] : null;
             if (focusedElement) {
                 if (focusedElement.tagName === 'INPUT' && focusedElement.type === 'range') {
                     if (inputStateMenu.navLeft) { inputStateMenu.valueLeft = true; inputStateMenu.navLeft = false; }
                     if (inputStateMenu.navRight) { inputStateMenu.valueRight = true; inputStateMenu.navRight = false; }
                 } else if (focusedElement.tagName === 'SELECT') {
                     if (inputStateMenu.navUp) { inputStateMenu.valueUp = true; inputStateMenu.navUp = false; }
                     if (inputStateMenu.navDown) { inputStateMenu.valueDown = true; inputStateMenu.navDown = false; }
                 }
             } else if (currentFocusIndex === -1 && focusableElements.length > 0 && (inputStateMenu.navUp || inputStateMenu.navDown || inputStateMenu.navLeft || inputStateMenu.navRight)) {
                 updateFocus(0);
                  inputStateMenu.navUp = inputStateMenu.navDown = inputStateMenu.navLeft = inputStateMenu.navRight = false;
             }
         }

        function applyInputActions() {
             const focusedElement = (currentFocusIndex !== -1) ? focusableElements[currentFocusIndex] : null;
             let actionTakenThisFrame = false;
             if (inputStateMenu.startGameShortcut) {
                 if (!inputHandled.startGameShortcut) {
                     // Le seul bouton de démarrage possible est startButton
                     let targetButton = (startButton && !startButton.disabled) ? startButton : null;
                     if (targetButton) {
                         // console.log(`[Input] Action: START SHORTCUT -> ${targetButton.id}`);
                         targetButton.click();
                         inputHandled.startGameShortcut = true;
                         actionTakenThisFrame = true;
                     }
                 }
             } else inputHandled.startGameShortcut = false;
             if (!actionTakenThisFrame && inputStateMenu.activate) {
                 if (!inputHandled.activate) {
                     // console.log("[Input] Action: ACTIVATE STANDARD");
                     activateFocusedElement();
                     actionTakenThisFrame = true;
                     inputHandled.activate = true;
                 }
             } else inputHandled.activate = false;
             if (!actionTakenThisFrame) {
                 let valueAction = null;
                 if (inputStateMenu.valueUp) valueAction = 'Up';
                 if (inputStateMenu.valueDown) valueAction = 'Down';
                 if (inputStateMenu.valueLeft) valueAction = 'Left';
                 if (inputStateMenu.valueRight) valueAction = 'Right';
                 if (valueAction) {
                     if (!inputHandled.valueChange) {
                          // console.log(`[Input] Action: VALUE CHANGE (${valueAction})`);
                          handleValueChange(focusedElement, valueAction);
                          actionTakenThisFrame = true;
                          inputHandled.valueChange = true;
                     }
                 } else inputHandled.valueChange = false;
             }
             if (!actionTakenThisFrame) {
                 let navAction = null;
                 if (inputStateMenu.navUp && !inputHandled.navUp) { navAction = 'Up'; inputHandled.navUp = true; }
                 if (inputStateMenu.navDown && !inputHandled.navDown) { navAction = 'Down'; inputHandled.navDown = true; }
                 if (inputStateMenu.navLeft && !inputHandled.navLeft) { navAction = 'Left'; inputHandled.navLeft = true; }
                 if (inputStateMenu.navRight && !inputHandled.navRight) { navAction = 'Right'; inputHandled.navRight = true; }
                 if (navAction) {
                     // console.log(`[Input] Action: NAVIGATE (${navAction})`);
                     navigate(navAction);
                     actionTakenThisFrame = true;
                 }
                 if (!inputStateMenu.navUp) inputHandled.navUp = false;
                 if (!inputStateMenu.navDown) inputHandled.navDown = false;
                 if (!inputStateMenu.navLeft) inputHandled.navLeft = false;
                 if (!inputStateMenu.navRight) inputHandled.navRight = false;
             }
         }

        function updateSoundButtonVisuals() {
            if (!soundToggleButton) return;
            soundToggleButton.classList.toggle('muted', isMenuSoundMuted);
            soundToggleButton.textContent = isMenuSoundMuted ? '🔇' : '🔊';
            // Utiliser translate ici, après que i18n soit initialisé
            soundToggleButton.title = translate(isMenuSoundMuted ? 'sound.enable' : 'sound.disable');
        }

        function toggleMenuSound() {
            if (!menuMusic) return;
            isMenuSoundMuted = !isMenuSoundMuted;
            localStorage.setItem('genesisTrail_menuSoundMuted', isMenuSoundMuted);
            updateSoundButtonVisuals();

            // --- Play/Pause Logic ---
            if (isMenuSoundMuted) {
                if (!menuMusic.paused) {
                     console.log("[Menu Audio] Musique mise en pause (Mute).");
                    menuMusic.pause();
                }
            } else {
                // Try to play only if interaction happened OR if it's already playing (unmute case)
                 if (firstInteractionDone || !menuMusic.paused) {
                     console.log("[Menu Audio] Tentative de (re)lecture (Unmute/Interaction).");
                     tryStartMusicAfterInteraction(); // Utiliser cette fonction pour gérer la lecture
                 } else {
                      console.log("[Menu Audio] Unmute, mais interaction utilisateur requise pour démarrer.");
                      // On ne joue pas encore, on attend tryStartMusicAfterInteraction()
                 }
            }
        }

        // Function to try playing music, typically after first user interaction
        async function tryStartMusicAfterInteraction() {
            if (!menuMusic || !firstInteractionDone || isMenuSoundMuted || !menuMusic.paused) {
                 // Ne rien faire si: pas de musique, pas d'interaction, muet, ou déjà en lecture
                return;
            }
            try {
                console.log("[Menu Audio] Tentative de lecture après interaction...");
                await menuMusic.play();
                console.log("[Menu Audio] Lecture démarrée avec succès.");
            } catch (error) {
                console.warn("[Menu Audio] Échec de la lecture automatique (peut nécessiter une autre interaction) :", error);
                 // Optionnel: Afficher un message à l'utilisateur
            }
        }

        // --- Add event listener to mark first interaction and try playing music ---
         function handleFirstInteraction() {
             if (!firstInteractionDone) {
                 console.log("[Menu Interaction] Première interaction détectée.");
                 firstInteractionDone = true;
                 tryStartMusicAfterInteraction(); // Essayer de jouer la musique maintenant
                 // Remove the listener after first interaction
                 document.body.removeEventListener('click', handleFirstInteraction, true);
                 document.body.removeEventListener('keydown', handleFirstInteraction, true);
             }
         }
         // Listen for clicks or keydowns anywhere on the body initially
         document.body.addEventListener('click', handleFirstInteraction, { capture: true, once: true }); // Use once if possible, or remove manually
         document.body.addEventListener('keydown', handleFirstInteraction, { capture: true, once: true });
        // --- End first interaction handling ---

        function captureStartButtonSpans() {
             if (startButton) {
                 startGameButtonSpan = startButton.querySelector('span[data-translate-key]');
                 if (startGameButtonSpan) startGameOriginalTranslateKey = startGameButtonSpan.getAttribute('data-translate-key');
             }
             // startVRButtonSpan = null; // Nettoyage non nécessaire, variable supprimée
         }
        function updateStartButtonTextHint(isGamepadConnected) {
             const hintText = isGamepadConnected ? translate('menu.startGameHint') : '';
             if (startGameButtonSpan && startGameOriginalTranslateKey) {
                 const originalText = translate(startGameOriginalTranslateKey);
                 startGameButtonSpan.textContent = `${originalText}${hintText}`;
             }
             // startVRButtonSpan = null; // Nettoyage non nécessaire, variable supprimée
         }

        // --- NOUVELLE FONCTION : Mise à jour de la description du mode --- 
        function updateModeDescription() {
            const descriptionElement = document.getElementById('mode-description');
            if (!descriptionElement) return;
            
            let descriptionKey = 'mode.description.default'; // Clé par défaut
            if (selectedMode) {
                if (selectedMode === 'customCourse') {
                    descriptionKey = 'mode.description.custom_course';
                } else if (selectedMode === 'customExploration') {
                    descriptionKey = 'mode.description.custom_exploration';
                // <<< ADDED: Handle Mission Mode Descriptions >>>
                } else if (selectedMode === 'customMission') {
                    descriptionKey = 'mode.description.custom_mission';
                } else if (selectedMode === 'mission_corridor') {
                    descriptionKey = 'mode.description.mission_corridor';
                // <<< ADDED: Handle Time Extension Mode Description >>>
                } else if (selectedMode === 'time_extension') {
                    descriptionKey = 'mode.description.time_extension';
                // <<< END ADDED >>>
                } else {
                    descriptionKey = `mode.description.${selectedMode.toLowerCase()}`;
                }
            }
            
            let description = translate(descriptionKey);
            // Fallback si la clé spécifique n'existe pas
            if (description === descriptionKey) {
                description = translate('mode.description.default');
            }
            
            descriptionElement.textContent = description;
        }

        // --- Écouteurs d'événements ---
        if (languageSelect) {
            languageSelect.value = getCurrentLanguage(); // getCurrentLanguage reste synchrone
            languageSelect.addEventListener('change', async (e) => {
                console.log(`[Menu] Changement de langue demandé vers: ${e.target.value}`);
                await setLanguage(e.target.value);
                updateUIText(); // Mettre à jour tout le texte
                updatePresetDescription(selectedControllerPreset); // Mettre à jour la description du preset
                setupControllerPresetSelector(); // Recréer les options du sélecteur de preset avec la nouvelle langue
                updateModeDescription(); // Mettre à jour la description du mode
                updateSoundButtonVisuals(); // Mettre à jour le title du bouton son
                applyLayout(currentLayout); // Mettre à jour le title du bouton layout
                captureStartButtonSpans(); // Recapturer les spans après màj UI pour l'indice manette
                updateStartButtonTextHint(gamepadConnected); // Mettre à jour l'indice (Start)
            });
        } else { console.warn("Element #languageSelect non trouvé."); }
        if (layoutToggleButton) layoutToggleButton.addEventListener('click', toggleLayout);
        if (soundToggleButton) soundToggleButton.addEventListener('click', toggleMenuSound);
        document.body.addEventListener('click', tryStartMusicAfterInteraction, { once: true });
        document.body.addEventListener('keydown', tryStartMusicAfterInteraction, { once: true });
        modeButtons.forEach(button => {
             // Initialisation: Vérifier si ce bouton correspond au mode chargé depuis localStorage
             if (button.dataset.mode === selectedMode) {
                 button.classList.add('selected');
                 // Pas besoin d\'appeler updateModeDescription ou updateCustomSectionsVisibility ici
                 // car c\'est déjà fait plus bas dans l\'initialisation globale.
             }
             
             // Listener de clic
             button.addEventListener('click', () => {
                 if (selectedMode === button.dataset.mode) return; // Ne rien faire si on clique sur le mode déjà actif
                 
                 // Mettre à jour l\'état
                 selectedMode = button.dataset.mode;
                 localStorage.setItem('genesisTrail_gameMode', selectedMode);
                 
                 // Mettre à jour le visuel des boutons
                 modeButtons.forEach(btn => btn.classList.remove('selected', focusClass));
                 button.classList.add('selected');

                 // <<< CORRECTION ICI : Utiliser la fonction centralisée >>>
                 updateCustomSectionsVisibility(); // Gère l\'affichage des DEUX sections custom
                 
                 // Mettre à jour les autres éléments UI
                 updateModeDescription(); // Mettre à jour la description affichée
                 checkStartConditions(); // Vérifier si on peut démarrer
                 updateFocusableElements(); // Recalculer les éléments focusables
                 tryStartMusicAfterInteraction(); // Essayer de démarrer la musique si première interaction
                 
                 console.log(`[Mode Click] Mode sélectionné: ${selectedMode}`); // Log
             });
         });
        if (customOpponentsSlider && opponentsValueSpan) {
             initializeCustomControl(customOpponentsSlider, 'opponentCount', opponentsValueSpan, 3, 'customCourse');
         }
        if (customLapsSlider && lapsValueSpan) {
             initializeCustomControl(customLapsSlider, 'lapCount', lapsValueSpan, 3, 'customCourse');
         }
        if (customObstaclesSlider && obstaclesValueSpan) {
             initializeCustomControl(customObstaclesSlider, 'obstacleCount', obstaclesValueSpan, 75, 'customCourse');
         }
        if (customTrackShapeSelect && customTrackComplexitySlider && complexityValueSpan && customTrackSizeSlider && sizeValueSpan && customTrackElevationSlider && elevationValueSpan && customTrackIrregularitySlider && irregularityValueSpan) {
             initializeCustomControl(customTrackShapeSelect, 'trackShape', null, 0, 'customCourse');
             initializeCustomControl(customTrackComplexitySlider, 'trackComplexity', complexityValueSpan, 20, 'customCourse');
             initializeCustomControl(customTrackSizeSlider, 'trackSize', sizeValueSpan, 550, 'customCourse');
             initializeCustomControl(customTrackElevationSlider, 'trackElevation', elevationValueSpan, 80, 'customCourse');
             initializeCustomControl(customTrackIrregularitySlider, 'trackIrregularity', irregularityValueSpan, 25, 'customCourse');
         }
        if (customExplorationObstaclesSlider && obstaclesExplValueSpan) {
            initializeCustomControl(customExplorationObstaclesSlider, 'obstacleCount', obstaclesExplValueSpan, 50, 'customExploration');
        }
        if (customExplorationSpeedSlider && speedExplValueSpan) {
            initializeCustomControl(customExplorationSpeedSlider, 'shipSpeedMultiplier', speedExplValueSpan, 1.0, 'customExploration');
        }
        if (customExplorationTimerSelect) {
            initializeCustomControl(customExplorationTimerSelect, 'timerDuration', null, '0', 'customExploration');
        }
        if (customExplorationEnvironmentSelect) {
            initializeCustomControl(customExplorationEnvironmentSelect, 'environmentIndex', null, 0, 'customExploration');
        }
        if (controllerPresetSelect) {
             controllerPresetSelect.addEventListener('change', (event) => {
                 selectedControllerPreset = event.target.value;
                 localStorage.setItem('genesisTrail_controllerPreset', selectedControllerPreset);
                 updatePresetDescription(selectedControllerPreset);
             });
         }
        shipButtons.forEach(button => {
             if (button.dataset.ship === selectedShip) button.classList.add('selected');
             button.addEventListener('click', () => {
                 shipButtons.forEach(btn => btn.classList.remove('selected'));
                 button.classList.add('selected');
                 selectedShip = button.dataset.ship;
                 selectedShipOption = button;
                 updateFocusableElements();
                 checkStartConditions();
             });
         });
         if (startButton) {
             startButton.addEventListener('click', () => {
                 if (!startButton.disabled) launchGame('non-vr');
             });
         } else { console.error("#startGame not found!"); }
         document.addEventListener('keydown', (e) => {
             if (e.target instanceof HTMLInputElement && e.target.type !== 'range' || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) return;
             inputStateMenu._rawKeyDown[e.code] = true;
             inputStateMenu._rawKeyUp[e.code] = false;
             if (currentFocusIndex !== -1 && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Space', 'Enter'].includes(e.code)) e.preventDefault();
             else if (currentFocusIndex === -1 && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.code)) e.preventDefault();
             lastInputType = 'keyboard';
         });
         document.addEventListener('keyup', (e) => {
             if (e.target instanceof HTMLInputElement && e.target.type !== 'range' || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) return;
             inputStateMenu._rawKeyDown[e.code] = false;
             inputStateMenu._rawKeyUp[e.code] = true;
             lastInputType = 'keyboard';
         });
          document.addEventListener('mousemove', () => { lastInputType = 'mouse'; });
          document.addEventListener('mousedown', (event) => {
              lastInputType = 'mouse';
              const clickedElement = event.target;
              const isClickInsideFocusable = focusableElements.some(el => el.contains(clickedElement));
              if (!isClickInsideFocusable && currentFocusIndex !== -1) updateFocus(-1);
          });
         window.addEventListener("gamepadconnected", (event) => {
             console.log(`[Gamepad Event] Manette connectée: ${event.gamepad.id}`);
             checkGamepadStatus();
         });
         window.addEventListener("gamepaddisconnected", (event) => {
             console.log(`[Gamepad Event] Manette déconnectée: ${event.gamepad.id}`);
             checkGamepadStatus();
         });

        // --- Initialisation Finale --- (Maintenant dans l'async IIFE)
        console.log("[Menu] Exécution de l'initialisation finale...");

        // Les textes UI sont déjà mis à jour par detectLanguage() via setLanguage()

        populateEnvironmentSelector(customEnvironmentSelect, 'customCourse');
        populateEnvironmentSelector(customExplorationEnvironmentSelect, 'customExploration');

        if (customMissionSetupSection) customMissionSetupSection.style.display = (selectedMode === 'custom_course') ? 'block' : 'none';
        checkStartConditions();

        // Vérifie la manette UNIQUEMENT pour gérer la VISIBILITÉ initiale
        const initialGamepads = navigator.getGamepads ? Array.from(navigator.getGamepads()) : [];
        if (initialGamepads.some(gp => gp && gp.connected)) {
            gamepadConnected = true;
            if (controllerPresetSection) {
                 // setupControllerPresetSelector(); // <<< APPEL RETIRÉ D'ICI >>>
                 controllerPresetSection.style.display = 'block'; // Gère seulement la visibilité
            } else { console.warn("Section preset manette non trouvée à l'init !"); }
        } else {
            gamepadConnected = false; // Assurer que c'est faux si aucune manette
            if (controllerPresetSection) controllerPresetSection.style.display = 'none'; // Cacher si pas de manette
        }

        applyLayout(currentLayout); // Appelle translate
        updateSoundButtonVisuals(); // Appelle translate
        captureStartButtonSpans();
        updateStartButtonTextHint(gamepadConnected); // Appelle translate
        updateFocusableElements();
        checkStartConditions();

        if (menuMusic && !isMenuSoundMuted) {
            menuMusic.volume = MENU_SOUND_VOLUME;
            menuMusic.play().catch(e => { /* console.warn("Lecture auto initiale échouée:", e) */ });
        }

        console.log("[Menu] Initialisation complète. Lancement boucle updateMenuLoop.");
        // <<< AJOUT: Forcer une dernière mise à jour UI après toute l'initialisation async >>>
        console.log("[Menu] Appel explicite de updateUIText FINAL...");
        await updateUIText();
        console.log("[Menu] Appel explicite de updateUIText FINAL TERMINÉ.");

        requestAnimationFrame(function updateMenuLoop(timestamp) {
            handleMenuInputs();
            applyInputActions();
            requestAnimationFrame(updateMenuLoop);
        });

        // --- FONCTION UTILITAIRE : Initialiser un slider/select depuis customConfig (Déplacée ici) ---
        function initializeCustomControl(element, configKey, valueSpan = null, defaultValue = null, configObjectName) {
            if (!element) {
                // console.warn(`Élément de contrôle pour ${configKey} non trouvé.`);
                return;
            }

            let configObject;
            if (configObjectName === 'customCourse') {
                configObject = customCourseConfig;
            } else if (configObjectName === 'customExploration') {
                configObject = customExplorationConfig;
            } else {
                console.error(`Nom d'objet de configuration inconnu: ${configObjectName}`);
                return;
            }


            let initialValue = configObject[configKey];

            // Si la valeur n'est pas dans la config sauvegardée, utiliser la valeur par défaut
            if (initialValue === undefined && defaultValue !== null) {
                initialValue = defaultValue;
                configObject[configKey] = initialValue; // Sauvegarder la valeur par défaut dans l'objet en mémoire
            }
            // Si toujours indéfinie (pas de défaut), logguer et potentiellement retourner
            if (initialValue === undefined) {
                 // console.warn(`Pas de valeur initiale ou par défaut pour ${configKey} dans ${configObjectName}.`);
                 // On pourrait vouloir arrêter ici ou définir une valeur 'safe'
                 // element.disabled = true; // Option: désactiver l'élément
                 return; // Pour l'instant, on ne fait rien si pas de valeur
            }

            // Appliquer la valeur initiale à l'élément et au span
            element.value = initialValue;
            if (valueSpan) {
                // <<< AJOUT Logs Debug >>>
                console.log(`[Slider Update] ID: ${element.id}, Span trouvé: ${valueSpan ? 'Oui' : 'Non'}, Nouvelle Valeur: ${initialValue}`);
                if (valueSpan) { // Re-vérifier ici après le log
                     if (element.id === 'custom-expl-speed') {
                         valueSpan.textContent = initialValue.toFixed(1) + 'x'; // Ajoute 'x' et assure une décimale
                     } else {
                         valueSpan.textContent = initialValue; // Comportement normal pour les autres
                     }
                }
            }

            // Ajouter un listener pour mettre à jour l'objet config et le span en temps réel
            const eventType = (element.type === 'range') ? 'input' : 'change';
            element.addEventListener(eventType, (e) => {
                // <<< RETRAIT Log Déplacé >>>
                // console.log(`[Listener Fired] ID: ${element.id}, Type: ${eventType}`);
                
                let newValue = e.target.value;
                 // Convertir en nombre si c\'est un range ou si la valeur par défaut était un nombre
                if (element.type === 'range' || typeof defaultValue === 'number') {
                    newValue = (element.type === 'range' && element.step && element.step.includes('.'))
                               ? parseFloat(newValue)
                               : parseInt(newValue, 10);
                }
                configObject[configKey] = newValue;
                if (valueSpan) {
                    // <<< RETRAIT Log Debug >>>
                    // console.log(`[Slider Update] ID: ${element.id}, Span trouvé: ${valueSpan ? \'Oui\' : \'Non\'}, Nouvelle Valeur: ${newValue}`);
                    if (valueSpan) { // Re-vérifier ici après le log
                         if (element.id === 'custom-expl-speed') {
                             valueSpan.textContent = newValue.toFixed(1) + 'x'; // Ajoute 'x' et assure une décimale
                         } else {
                             valueSpan.textContent = newValue; // Comportement normal pour les autres
                         }
                    }
                }
                // console.log(`[Custom ${configObjectName}] ${configKey} mis à jour: ${newValue}`); // Optionnel: log
            });
        }

    })(); // Fin de l'async IIFE

}); 